import { useEffect, useState } from "react";
import { formatNumber } from "../../utils/numbers";
import Modal from "../Modal/Modal";
import Select from "../Select/Select";
import loadingGreen from "../../images/loading_gray.gif";
import plusIcon from "../../images/icon_plus.svg";
import deleteIcon from "../../images/icon_delete.svg";
import Input from "../Input/Input";
import RequestedInput from "../RequestedInput/RequestedInput";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { Checkbox } from "primereact/checkbox";

import {
  MainButton,
  Container,
  Row,
  WithdrawalByHandContainer,
  GrayBox,
  ButtonContainer,
  CancelButton,
} from "./VctAppointmentRequestStyles";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import { useAsyncExecutor2 } from "async-executor-hook";
import { DOCUMENT_DNI_MAX_LENGTH } from "../../utils/valueStaticConstants";

const MAX_PLATE_VEHICLES = 10;

function populateOptions(options) {
  return options.map((option, index) => {
    return (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    );
  });
}

function getNewVehicle() {
  return {
    plate: "",
    category: "",
    driverName: "",
    driverDocumentNumber: "",
    driverLicense: "",
    hasError: false,
    driverHasError: false,
    driverChecked: false,
  };
}

function VctAppointmentRequest(props) {
  const {
    summaryVctVolantes,
    dispatchers,
    vehicleCategories,
    timeslots,
    withdrawalDate,
    showModalHide,
    modalHideAppointment,
    updateShowConfirmationModal,
    onErrorAppoiment,
    countPageRedirect,
    dateUrl,
    shoppingCar,
    getAppointmentVolantes,
  } = props;

  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [showNoTransportModal, setShowNoTransportModal] = useState(false);
  const [showVehicleModalWarning, setShowVehicleModalWarning] = useState(false);
  const [vehicleMessageWarning, updateVehicleMessageWarning] = useState("");
  const [showDniModalWarning, setShowDniModalWarning] = useState(false);
  const [dniMessageWarning, updateDniMessageWarning] = useState("");
  const [withdrawalType, setWithdrawalType] = useState("with_transport");

  useEffect(() => {
    getAppointmentVolantes.execute({ shoppingCar });
    // eslint-disable-next-line
  }, []);

  const [request, updateRequest] = useState({
    customsDispatcherId: "1",
    volanteNums: summaryVctVolantes.volanteIds,
    timeslotId: "",
    withdrawalByHand: false,
    withoutTransport: false,
    vehicles: [getNewVehicle()],
  });
  const onWithdrawalByHandCheck = (e) => {
    const newUpdateRequest = {
      ...request,
      withdrawalByHand: !request.withdrawalByHand,
      withoutTransport: false,
      withdrawal_type: "without_transport",
    };
    updateRequest(newUpdateRequest);
    if (e.target.checked) {
      setWithdrawalType("without_transport");
    } else {
      setWithdrawalType("with_transport");
    }
    isChangeSelect(newUpdateRequest);
  };

  const onWithoutTransportCheck = (e) => {
    const newUpdateRequest = {
      ...request,
      withoutTransport: !request.withoutTransport,
      withdrawalByHand: false,
      withdrawal_type: "pending_selection",
    };
    updateRequest(newUpdateRequest);
    if (e.target.checked) {
      setWithdrawalType("pending_selection");
    } else {
      setWithdrawalType("with_transport");
    }

    isChangeSelect(newUpdateRequest);
  };

  function updateRequestField(modifierFn) {
    let newRequest = { ...request };
    modifierFn(newRequest);
    updateRequest(newRequest);
    isChangeSelect(newRequest);
  }

  function addVehicle() {
    if (request.withoutTransport) {
      updateVehicleMessageWarning(
        "Le informamos que no es posible registrar transportistas con la opción <<cita sin transporte>> marcada."
      );
      setShowVehicleModalWarning(true);
      return;
    }
    if (request.vehicles.length >= vehicleCategories.maxVehicles) {
      updateVehicleMessageWarning(
        `Le informamos que solo es posible registrar como máximo ${vehicleCategories.maxVehicles} transportistas por cada cita.`
      );
      setShowVehicleModalWarning(true);
      return;
    }
    let newRequest = { ...request };
    newRequest.vehicles.push(getNewVehicle());
    updateRequest(newRequest);
    isChangeSelect(newRequest);
  }

  function deleteVehicle(idx) {
    let newRequest = { ...request };
    newRequest.vehicles.splice(idx, 1);
    updateRequest(newRequest);
    isChangeSelect(newRequest);
  }

  const onButtonClick = () => {
    if (request.withoutTransport) {
      setShowNoTransportModal(true);
      return;
    }
    onConfirm();
  };

  const onConfirm = () => {
    const withdrawal_type = withdrawalType;
    if (waitingServerResponse) return;
    let validRequest = true;
    let newRequest = { ...request };
    if (request.withdrawalByHand || request.withoutTransport) {
      newRequest.vehicles = [];
    } else {
      newRequest.vehicles.forEach((vehicle, index) => {
        if (vehicle.plate.length === 0) {
          newRequest.vehicles[index].hasError = true;
          validRequest = false;
        }
        if (
          vehicle.driverDocumentNumber.length === 0 ||
          vehicle.driverLicense.length === 0 ||
          vehicle.driverName.length === 0
        ) {
          newRequest.vehicles[index].driverHasError = true;
          validRequest = true;
        }
      });
    }
    updateRequest(newRequest);
    isChangeSelect(newRequest);
    if (!validRequest) return;

    updateWaitingServerResponse(true);
    createAppointment(request, withdrawal_type)
      .then(() => {
        getQuotationQuoted.execute({ from_date: dateUrl });
      })
      .catch((error) => {
        onErrorAppoiment(error);
        modalHideAppointment();
        updateWaitingServerResponse(false);
      });
  };
  const getQuotationQuoted: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest(`/volantes/appointment/`, HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        const count = data.count;

        updateWaitingServerResponse(false);
        updateShowConfirmationModal(true);
        modalHideAppointment();
        setShowNoTransportModal(false);

        countPageRedirect(count);
      },
      onError: () => {
        countPageRedirect(1);
        updateWaitingServerResponse(false);
        updateShowConfirmationModal(true);
        modalHideAppointment();
        setShowNoTransportModal(false);
      },
    }
  );

  const onClose = () => {
    if (props.hideModal != null) {
      props.hideModal(true);
    }
  };

  const isHandPickupDisabled = Number(summaryVctVolantes.parcelsWeight) > 30;
  const [nameDispatcherName, updateNameDispatcherName] = useState(false);
  const [timeWithDrawalDate, updateTimeWithDrawalDate] = useState(false);
  const [typeVehicle, updateTypeVehicle] = useState(false);
  const [licensePlate, updateLicensePlate] = useState(false);
  const [dniValidate, updateDniValidate] = useState(false);

  const [showMessageErrorAppointment, setShowMessageErrorAppointment] =
    useState("");
  const isChangeSelect = (requestDataVehicles) => {
    const dataVehicles = requestDataVehicles.vehicles.filter(
      (vehicleC) =>
        vehicleC.category.length > 0 &&
        vehicleC.plate.length > 0 &&
        vehicleC.driverName.length > 0 &&
        vehicleC.driverLicense.length > 0 &&
        vehicleC.driverChecked === true
    );
    const vehiclesData = requestDataVehicles.vehicles.map(
      (vehicle) => vehicle.driverDocumentNumber
    );

    const filterVehicleRepeat = vehiclesData.filter((item, index) => {
      return vehiclesData.indexOf(item) === index;
    });

    if (requestDataVehicles.vehicles.length === dataVehicles.length) {
      if (filterVehicleRepeat.length === requestDataVehicles.vehicles.length) {
        updateLicensePlate(true);
        setShowMessageErrorAppointment("");
      } else if (filterVehicleRepeat.length !== vehiclesData.length) {
        setShowMessageErrorAppointment(
          "DNI duplicado, ingrese datos correctos"
        );
      } else {
        updateLicensePlate(false);
        setShowMessageErrorAppointment("");
      }
    } else if (vehiclesData.length === filterVehicleRepeat.length) {
      updateLicensePlate(false);
      setShowMessageErrorAppointment("");
    } else {
      setShowMessageErrorAppointment("DNI duplicado, ingrese datos correctos");
    }
  };

  const isButtonDisabledvehicle =
    !nameDispatcherName ||
    !timeWithDrawalDate ||
    !typeVehicle ||
    !licensePlate ||
    !dniValidate;

  const isButtonDisabledHand =
    !nameDispatcherName ||
    !timeWithDrawalDate ||
    (!request.withdrawalByHand && !request.withoutTransport);

  const isButtonDisabled = !isButtonDisabledvehicle || !isButtonDisabledHand;

  const [DniBlankShow, setDniBlankShow] = useState(false);
  const dniBlankFilter = (request_payload) => {
    const driversDocumentNumber = request_payload.vehicles
      .map((document) => document.driverDocumentNumber)
      .filter((e: string) => e === "");
    const driversLicense = request_payload.vehicles
      .map((document) => document.driverLicense)
      .filter((e: string) => e === "");
    if (driversDocumentNumber.length > 0 || driversLicense.length > 0) {
      setDniBlankShow(true);
    } else {
      setDniBlankShow(false);
    }
  };
  useEffect(() => {
    dniBlankFilter(request);
  }, [request]);

  return (
    <>
      {showModalHide && (
        <Modal onOutsideClick={onClose}>
          <Container>
            <h1>Programar Cita</h1>
            <div>
              <div className="row">
                <p>Cantidad de volantes</p>
                <p className="p-value">{summaryVctVolantes.volantesQty}</p>
              </div>

              <div className="row">
                <p>Nº de grupos</p>
                <p className="p-value">{summaryVctVolantes.groupsTotal}</p>
              </div>

              <div className="row">
                <p>Cantidad de kilos</p>
                <p className="p-value">
                  {formatNumber(summaryVctVolantes.parcelsWeight)}
                </p>
              </div>
              <div className="row">
                <p>Segmento</p>
                <p className="p-value">
                  {identifySegment(
                    summaryVctVolantes.groupsTotal,
                    request.vehicles.map((v) => v.category),
                    request.withdrawalByHand,
                    request.withoutTransport
                  )}
                </p>
              </div>
              <div className="row">
                <p>Fecha de retiro</p>
                <p className="p-value">{withdrawalDate}</p>
              </div>
              <Row className="row-title">
                <h2>NOMBRE DEL DESPACHADOR</h2>
              </Row>
              <Select
                name={"dispatcherName"}
                onChange={(e) => {
                  updateRequestField((request) => {
                    request.customsDispatcherId = e.target.value;
                    if (request.customsDispatcherId.length > 3) {
                      updateNameDispatcherName(true);
                    } else {
                      updateNameDispatcherName(false);
                    }
                  });
                }}
                value={request.customsDispatcherId}
                width="fill-available"
                arrowPosition="2.2rem"
              >
                {populateOptions(dispatchers)}
              </Select>
              <Row className="row-title">
                <h2>HORA DE RETIRO</h2>
              </Row>
              <Row>
                <Select
                  onChange={(e) => {
                    updateRequestField((request) => {
                      request.timeslotId = e.target.value;
                      if (request.timeslotId.length > 3) {
                        updateTimeWithDrawalDate(true);
                      } else {
                        updateTimeWithDrawalDate(false);
                      }
                    });
                  }}
                  value={request.timeslotId}
                  width="fill-available"
                >
                  {populateOptions(timeslots)}
                </Select>
              </Row>
              <div className="request-options">
                <WithdrawalByHandContainer>
                  <Checkbox
                    onChange={onWithdrawalByHandCheck}
                    onClick={(e) => e.stopPropagation()}
                    disabled={isHandPickupDisabled}
                    tooltip={
                      isHandPickupDisabled
                        ? "El peso de la carga es mayor a 30 kg."
                        : null
                    }
                    checked={request.withdrawalByHand}
                  />
                  <span>Retiro a mano</span>
                </WithdrawalByHandContainer>
                <WithdrawalByHandContainer>
                  <Checkbox
                    onChange={onWithoutTransportCheck}
                    onClick={(e) => e.stopPropagation()}
                    checked={request.withoutTransport}
                  />
                  <span>Citas sin datos del transporte</span>
                </WithdrawalByHandContainer>
              </div>
              {!request.withdrawalByHand &&
                !request.withoutTransport &&
                request.vehicles.map((vehicle, i) => {
                  return (
                    <div key={i}>
                      {request.vehicles.length > 1 ? (
                        <div
                          className="delete-vehicle"
                          onClick={() => deleteVehicle(i)}
                        >
                          <img src={deleteIcon} alt="Eliminar" />
                          Eliminar
                        </div>
                      ) : null}
                      <div className="vehicle-box">
                        <Row>
                          <div>
                            <h2>TIPO DE VEHÍCULO</h2>
                            <Select
                              name={"vehicleCategory" + i}
                              onChange={(e) => {
                                updateRequestField((request) => {
                                  request.vehicles[i].category = e.target.value;
                                  if (request.vehicles[i].category.length > 1) {
                                    updateTypeVehicle(true);
                                  } else {
                                    updateTypeVehicle(false);
                                  }
                                });
                              }}
                              value={vehicle.category}
                              arrowPosition="2.2rem"
                              width="15rem"
                            >
                              {populateOptions(vehicleCategories.labels)}
                            </Select>
                          </div>
                          <div>
                            <h2>PLACA</h2>
                            <Input
                              type="text"
                              className="licensePlate"
                              onChange={(e) => {
                                updateRequestField((request) => {
                                  request.vehicles[i].hasError = false;
                                  request.vehicles[i].plate = e.target.value;
                                });
                              }}
                              value={vehicle.plate}
                              hasError={vehicle.hasError}
                              width="18rem"
                              maxLength={MAX_PLATE_VEHICLES}
                            />
                          </div>
                        </Row>
                        <Row>
                          <div>
                            <h2>DNI</h2>
                            <RequestedInput
                              hasError={request.vehicles[i].driverHasError}
                              width="15rem"
                              value={request.vehicles[i].driverDocumentNumber}
                              onChangeValue={(ev) => {
                                updateRequestField((request) => {
                                  request.vehicles[i].driverDocumentNumber =
                                    ev.target.value;
                                  request.vehicles[i].driverName = "";
                                  request.vehicles[i].driverLicense = "";
                                  request.vehicles[i].driverHasError = false;
                                });
                              }}
                              maxLength={DOCUMENT_DNI_MAX_LENGTH}
                              placeholder="DNI"
                              checked={vehicle.driverChecked}
                              onChangeCheck={(ev) => {
                                const newDriverCheckedStatus =
                                  ev.target.checked;
                                updateRequestField((request) => {
                                  request.vehicles[i].driverChecked =
                                    newDriverCheckedStatus;
                                });
                                if (newDriverCheckedStatus) {
                                  driverVerification(
                                    request.vehicles[i].driverDocumentNumber
                                  )
                                    .then((response) => {
                                      updateRequestField((request) => {
                                        request.vehicles[i].driverName =
                                          response.name;
                                        request.vehicles[i].driverLicense =
                                          response.brevete;
                                      });
                                      updateDniValidate(true);
                                    })
                                    .catch((error) => {
                                      updateRequestField((request) => {
                                        request.vehicles[i].driverHasError =
                                          true;
                                        request.vehicles[i].driverChecked =
                                          false;
                                      });
                                      updateDniValidate(false);
                                      const errorMessage =
                                        getErrorValueResponse(error);
                                      updateDniMessageWarning(errorMessage);
                                      setShowDniModalWarning(true);
                                    });
                                } else {
                                  updateRequestField((request) => {
                                    request.vehicles[i].driverName = "";
                                    request.vehicles[i].driverLicense = "";
                                  });
                                }
                              }}
                            />
                          </div>
                          <div>
                            <h2>BREVETE</h2>
                            <GrayBox width="18rem">
                              {vehicle.driverChecked && (
                                <span>{request.vehicles[i].driverLicense}</span>
                              )}
                            </GrayBox>
                          </div>
                        </Row>
                        <Row>
                          <div>
                            <h2>TRANSPORTISTA</h2>
                            <GrayBox width="38rem">
                              {vehicle.driverChecked && (
                                <span>{request.vehicles[i].driverName}</span>
                              )}
                            </GrayBox>
                          </div>
                        </Row>
                      </div>
                    </div>
                  );
                })}
            </div>
            {!DniBlankShow && (
              <>
                {!request.withdrawalByHand && !request.withoutTransport && (
                  <Row onClick={addVehicle}>
                    <img src={plusIcon} alt="Agregar" />
                    <h2 className="add-vehicle">Añadir vehículo</h2>
                  </Row>
                )}
              </>
            )}
            {!request.withdrawalByHand &&
              !request.withoutTransport &&
              showMessageErrorAppointment && (
                <div className="block-hint">{showMessageErrorAppointment}</div>
              )}
            <ButtonContainer>
              <Authorization actions={["appointment.create_appointments"]}>
                <MainButton
                  disabled={
                    !isButtonDisabled ||
                    (waitingServerResponse && !showNoTransportModal) ||
                    !getAppointmentVolantes.isSuccess
                  }
                  isLoading={waitingServerResponse && !showNoTransportModal}
                  onClick={onButtonClick}
                >
                  {waitingServerResponse && !showNoTransportModal ? (
                    <img
                      src={loadingGreen}
                      width="50"
                      height="50"
                      alt="Processing request"
                    />
                  ) : null}
                  Generar Cita
                </MainButton>
              </Authorization>
            </ButtonContainer>
          </Container>
        </Modal>
      )}
      {showVehicleModalWarning && (
        <ConfirmationModal
          message={vehicleMessageWarning}
          onAccept={() => {
            setShowVehicleModalWarning(false);
          }}
          title="Alerta de añadir vehículo"
          toggleModal={() => {
            setShowVehicleModalWarning(false);
          }}
        />
      )}
      {showDniModalWarning && (
        <ConfirmationModal
          message={dniMessageWarning}
          onAccept={() => {
            setShowDniModalWarning(false);
          }}
          title="Validación de DNI"
          toggleModal={() => {
            setShowDniModalWarning(false);
          }}
        />
      )}
      {showNoTransportModal && (
        <Modal
          onOutsideClick={() => {
            setShowNoTransportModal(false);
          }}
        >
          <Container>
            <h1>Cita sin transportista</h1>
            <p className="transport">
              Se tendrá que agregar los datos del transportista hasta una hora
              antes del momento de la cita.
            </p>
            <p className="transport">
              Cualquier consulta adicional contactarse con soporte TalmaClick.
            </p>
            <MainButton
              onClick={() => {
                onConfirm();
              }}
              disabled={waitingServerResponse}
            >
              {waitingServerResponse ? (
                <img
                  src={loadingGreen}
                  width="50"
                  height="50"
                  alt="Processing request"
                />
              ) : null}
              Generar Cita
            </MainButton>
            <CancelButton
              onClick={() => {
                setShowNoTransportModal(false);
              }}
              disabled={waitingServerResponse}
            >
              Cancelar
            </CancelButton>
          </Container>
        </Modal>
      )}
    </>
  );
}

export default VctAppointmentRequest;

export const SMALL_VEHICLES = ["car", "van", "minivan", "small_truck"];
export const SEGMENT_CATEGORY = {
  DOUBLE_DOCKS: "Diques dobles",
  GROUPS_1_TO_2: "De 1 a 2 grupos",
  GROUPS_3_TO_4: "De 3 a 4 grupos",
  GROUPS_5_AND_UPWARDS: "Más de 5 grupos",
};

export function identifySegment(
  groupsNum,
  vehiclesCategories,
  withdrawalByHand,
  withoutTransport = false
) {
  if (withdrawalByHand) return "Retiro a mano";
  if (
    withoutTransport ||
    vehiclesCategories.length === 0 ||
    !vehiclesCategories[0]
  )
    return "-";
  if (
    vehiclesCategories.length === 1 &&
    groupsNum <= 2 &&
    SMALL_VEHICLES.includes(vehiclesCategories[0])
  ) {
    return SEGMENT_CATEGORY.DOUBLE_DOCKS;
  }
  if (groupsNum <= 2) {
    return SEGMENT_CATEGORY.GROUPS_1_TO_2;
  }
  if (groupsNum <= 4) {
    return SEGMENT_CATEGORY.GROUPS_3_TO_4;
  }
  return SEGMENT_CATEGORY.GROUPS_5_AND_UPWARDS;
}

function createAppointment(request, withdrawal_type) {
  return networkBackendRequest(
    "/appointments/",
    HTTP_METHODS.POST,
    {},
    {
      customs_dispatcher_id: request.customsDispatcherId,
      volante_num_list: request.volanteNums,
      timeslot_id: request.timeslotId,
      withdrawal_type,
      vehicles:
        !request.withdrawalByHand && !request.withoutTransport
          ? request.vehicles.map((v) => {
              return {
                plate: v.plate,
                category_option: v.category,
                document_number: v.driverDocumentNumber,
                document_type: "dni",
              };
            })
          : [],
    }
  ).then((response) => response.json());
}

export function driverVerification(driverDocumentNumber) {
  return networkBackendRequest(
    `/drivers/${driverDocumentNumber}/`,
    HTTP_METHODS.GET,
    {
      document_type: "dni",
    }
  ).then((response) => response.json());
}
